import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import { PopoverAnimationVertical } from "material-ui/Popover";

import { formatPrice, formatInsertables } from "../../util";

class PassButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };

    this._hasPasses = this._hasPasses.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onClose = this._onClose.bind(this);
    this.makeMenuItems = this.makeMenuItems.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    tenant: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  _hasPasses() {
    return this.props.details.person && this.props.details.person.passes.length;
  }

  _onClick(e) {
    e.preventDefault();

    if (!this._hasPasses()) {
      this.context.router.push(this.props.target);
      return;
    }

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  makeMenuItems() {
    return this.props.details.person.passes
      .map(p => {
        let adjusted = this.props.details.pass_adjusted[p.id],
          usable = adjusted.quantity_available > 0;
        return {
          label: usable
            ? `Order using "${p.name}" ${
                p.pass_bucket.name
              } discount (${formatPrice(adjusted.price)})`
            : `Unable to apply "${p.name}" ${
                p.pass_bucket.name
              } discount: ${adjusted.errors.join(" ")}`,
          onClick: usable
            ? e => {
                let target = Object.assign({}, this.props.target);
                target.query.pass = p.id;
                this.context.router.push(target);
                this._onClose();
              }
            : undefined,
          disabled: !usable
        };
      })
      .concat(
        this.props.details.sales_disabled_unless_pass_rule
          ? []
          : [
              {
                label: `Order without using discount (${formatPrice(
                  this.props.price
                )})`,
                onClick: e => {
                  this.context.router.push(this.props.target);
                  this._onClose();
                }
              }
            ]
      );
  }

  getStyles() {
    return {
      menu: {
        maxWidth: this.context.isLarge ? 600 : "60vw",
        textAlign: "left"
      },
      menuItem: {
        cursor: "pointer",
        whiteSpace: "inherit",
        lineHeight: "25px",
        minHeight: "inherit",
        paddingTop: 4,
        paddingBottom: 4
      }
    };
  }

  render() {
    let { style, label, disabled } = this.props,
      styles = this.getStyles(),
      button = (
        <RaisedButton
          className="eventive__pass-button__button"
          disabled={disabled}
          label={label}
          primary={true}
          onClick={this._onClick}
        />
      );

    return this._hasPasses() ? (
      <div style={Object.assign({ display: "inline-block" }, style)}>
        {button}
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this._onClose}
          animation={PopoverAnimationVertical}
        >
          <Menu desktop={true} style={styles.menu}>
            {this.makeMenuItems().map(({ label, onClick, disabled }) => {
              return (
                <MenuItem
                  style={Object.assign(
                    {},
                    styles.menuItem,
                    disabled && { cursor: "initial" }
                  )}
                  primaryText={label}
                  onClick={onClick}
                  disabled={disabled}
                />
              );
            })}
          </Menu>
        </Popover>
      </div>
    ) : (
      button
    );
  }
}

export default PassButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-button.jsx